// Pagina generica para secoes ainda sem modulo de backend pronto (ex:
// Configuracoes - dependeria de mais telas de M4 do que o Dia 9 pedia).
// Reaproveitavel: so passar o nome da secao.
export function renderConstrucao(nomeSecao: string): string {
  return `
    <div class="card construcao">
      <div class="construcao__icone">🚧</div>
      <h2>${nomeSecao} em construção</h2>
      <p>Esta seção ainda não está disponível.</p>
    </div>
  `;
}
